import React from "react";

const BrandingAndCustomizationNote = () => {
  return (
    <>
      <div className="BrandingAndCustomization-note text-center">
        <strong>Note:</strong> White label customizations are only applied to
        events under gold plan.
      </div>
      <style>
        {`

        .BrandingAndCustomization-note {
            background-color: #ECF2FF;
            padding: 12px 64px;
            border-radius: 4px;
            font-size: 16px;
            color: #002E6E;
        }
       @media screen and (max-width: 576px) {
          .BrandingAndCustomization-note {
            padding: 12px 32px;
          }
        }


`}
      </style>
    </>
  );
};

export default BrandingAndCustomizationNote;
